var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',[_c('Container',{ref:"container",staticClass:"lottery-turntable2-page"},[_c('div',{staticClass:"rule-wrap"},[_c('div',{staticClass:"inner"},[_c('img',{attrs:{"src":_vm.raffle.raffleDescUrl}})])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }